module.exports = __webpack_public_path__ + "img/faming6.5b53bda0.png";